import { Avatar, type AvatarProps } from "@mui/material";
import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	getTimelineIconSpec,
	type TimelineIconTone,
} from "web_myplann/Shared/Utils/getTimelineIconSpec";

interface CategoryIconProps {
	item: Pick<TimelineItemResponseDTO, "category" | "subcategory">;
}

const TONE_VARIANT: Record<TimelineIconTone, AvatarProps["variant"]> = {
	teal: "softTeal",
	green: "softGreen",
	orange: "softOrange",
	blue: "softBlue",
	purple: "softPurple",
	grey: "softGrey",
};

const TONE_VARIANT_V2: Record<TimelineIconTone, AvatarProps["variant"]> = {
	...TONE_VARIANT,
	teal: "softTealV2",
	green: "softGreenV2",
};

const ICON_SIZE = 20;

export const CategoryIcon: FC<CategoryIconProps> = ({ item }) => {
	const hasGoalsRight = useGoalsRightOptional();
	const { Icon, tone } = getTimelineIconSpec(item);
	const toneVariant = hasGoalsRight ? TONE_VARIANT_V2 : TONE_VARIANT;

	return (
		<Avatar variant={toneVariant[tone]}>
			<Icon size={ICON_SIZE} />
		</Avatar>
	);
};
